// Turns a vendor's flexible price fields into a display string (or null = hide).
// Backward compatible: old vendors with only priceRange are treated as "tier".
export function formatPrice(v, sq) {
  if (!v) return null;
  const mode = v.priceMode || (v.priceRange ? "tier" : "none");
  const from = sq ? "Nga" : "From";
  if (mode === "tier") return v.priceRange || null;
  if (mode === "range") {
    const min = v.priceMin;
    const max = v.priceMax;
    if (min && max) return `€${min} – €${max}`;
    if (min) return `${from} €${min}`;
    if (max) return `${sq ? "Deri" : "Up to"} €${max}`;
    return null;
  }
  if (mode === "from") return v.priceFrom ? `${from} €${v.priceFrom}` : null;
  return null; // "none"
}
